import { render, staticRenderFns } from "./temporaryRemarks.vue?vue&type=template&id=4cec5818&scoped=true&"
import script from "./temporaryRemarks.vue?vue&type=script&lang=js&"
export * from "./temporaryRemarks.vue?vue&type=script&lang=js&"
import style0 from "./temporaryRemarks.vue?vue&type=style&index=0&id=4cec5818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec5818",
  null
  
)

export default component.exports